import { ScheduledPostsClient } from 'api/clients/ScheduledPostsClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation, useQueryClient } from 'react-query'
import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { scheduledPostsKeys } from './scheduledPostsKeys'

type UseDuplicateScheduledPostOptions = {
  onSuccess?: () => void
}

export const useDuplicateScheduledPost = (options?: UseDuplicateScheduledPostOptions) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  return useMutation(ScheduledPostsClient.duplicate, {
    onSuccess: () => {
      // Refresh both calendar-backed query families so the duplicate appears at its new date.
      queryClient.invalidateQueries(calendarKeys.all)
      queryClient.invalidateQueries(scheduledPostsKeys.calendar(workspaceId))
      showToastMessage('Post duplicated', 'success')
      options?.onSuccess?.()
    },
    onError: () => {
      showToastMessage('Unable to duplicate post', 'error')
    },
  })
}
